import React from 'react'

const SocialMediaFooter = () => (
  <footer id="social-media-footer" className="page-footer d-none d-lg-block">
    <div className="footer-left">
      <ul className="social">
        <li>
          <a
            href="https://linkedin.com/company/buschmais"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
            aria-label="Besuchen Sie unsere Präsenz auf LinkedIn"
          >
            <i className="icon icon-linkedin" />
          </a>
        </li>
        <li>
          <a
            href="https://vimeo.com/buschmais"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
            aria-label="Besuchen Sie unsere Präsenz auf Vimeo"
          >
            <i className="icon icon-vimeo" />
          </a>
        </li>
      </ul>
    </div>
  </footer>
)

export default SocialMediaFooter
